import {
    CheckCircleOutline,
    ExpandLess,
    ExpandMore,
    MoveToInbox,
    NoteAltOutlined,
    Notifications,
    Settings,
} from '@mui/icons-material'
import {
    Box,
    Collapse,
    Drawer,
    List,
    ListItem,
    ListItemButton,
    ListItemIcon,
    ListItemText,
    Typography,
} from '@mui/material'
import { useContext, useState } from 'react'
import { useLocation, useNavigate } from 'react-router-dom'
import { ApplicationContext } from '../App'

export const Navigation: React.FC = () => {
    const { identities, requests, notifications } = useContext(ApplicationContext)
    const pathname = useLocation().pathname
    const navigate = useNavigate()
    const isIntegrationRoute = pathname === '/api/claims'
    const isSubmitRoute = pathname.split('/')[1] === 'submit'
    const isEligibiltyRoute = pathname.split('/')[1] === 'eligibilty'
    const [claimsIntegrationExpanded, setClaimsIntegrationExpanded] = useState(isIntegrationRoute)
    const [validationPassed, setValidationPassed] = useState(false)
    const [submitClaimsExpanded, setSubmitClaimsExpanded] = useState(isSubmitRoute)
    const [eligibilityExpanded, setEligibilityExpanded] = useState(isEligibiltyRoute)
    const ownOrg = identities.find((entry) => entry.self)
    const orgName = ownOrg?.displayName ?? 'loading..'
    const logoFile = !orgName.includes('loading')
        ? `/img/orgs/${orgName.toLowerCase().replace(/ /g, '_')}.png`
        : ''
    return (
        <Drawer
            variant="permanent"
            PaperProps={{ style: { width: '250px', backgroundColor: '#00253F', color: 'white' } }}
        >
            <Box
                style={{
                    marginTop: '30px',
                    marginBottom: '40px',
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'center',
                }}
            >
                <img src={logoFile} alt="" />
                <Typography
                    variant="h5"
                    style={{ fontWeight: '600', marginLeft: '15px', marginRight: '15px' }}
                >
                    {orgName}
                </Typography>
            </Box>
            <Box>
                <List disablePadding style={{ marginTop: '0px' }}>
                    <ListItem disablePadding>
                        <ListItemButton selected={pathname === '/'} onClick={() => navigate('/')}>
                            <ListItemIcon style={{ marginLeft: '10px' }}></ListItemIcon>
                            <ListItemText>Home</ListItemText>
                        </ListItemButton>
                    </ListItem>
                    <ListItem disablePadding>
                        <ListItemButton
                            selected={isEligibiltyRoute}
                            onClick={() => setEligibilityExpanded(!eligibilityExpanded)}
                        >
                            <ListItemIcon style={{ marginLeft: '10px' }}>
                                <CheckCircleOutline style={{ color: '#b6d6ef' }} />
                            </ListItemIcon>
                            <ListItemText>Eligibility</ListItemText>
                            {eligibilityExpanded ? <ExpandLess /> : <ExpandMore />}
                        </ListItemButton>
                    </ListItem>
                    <Collapse in={eligibilityExpanded}>
                        <List component="div" disablePadding style={{ marginLeft: '10px' }}>
                            <ListItemButton
                                selected={
                                    pathname === '/eligibility/members' ||
                                    pathname === '/eligibility/patients'
                                }
                                onClick={() =>
                                    navigate(
                                        ownOrg?.type === 'payer'
                                            ? '/eligibility/members'
                                            : '/eligibility/patients',
                                    )
                                }
                            >
                                <ListItemIcon style={{ marginLeft: '10px' }} />
                                <ListItemText>
                                    {ownOrg?.type === 'payer' ? 'Member' : 'Patient'}
                                </ListItemText>
                            </ListItemButton>
                            {(ownOrg?.type ?? '').toLowerCase() === 'payer' && (
                                <ListItemButton
                                    selected={pathname === '/eligibility/products'}
                                    onClick={() => navigate('/eligibility/products')}
                                >
                                    <ListItemIcon style={{ marginLeft: '10px' }} />
                                    <ListItemText>Products</ListItemText>
                                </ListItemButton>
                            )}
                            {(ownOrg?.type ?? '').toLowerCase() === 'provider' && (
                                <ListItemButton
                                    selected={pathname === '/eligibility/submit'}
                                    onClick={() => navigate('/eligibility/submit')}
                                >
                                    <ListItemIcon style={{ marginLeft: '10px' }} />
                                    <ListItemText>EDI</ListItemText>
                                </ListItemButton>
                            )}
                            <ListItemButton
                                selected={pathname === '/eligibility/transactions'}
                                onClick={() => navigate('/eligibility/transactions')}
                            >
                                <ListItemIcon style={{ marginLeft: '10px' }} />
                                <ListItemText>Transactions</ListItemText>
                            </ListItemButton>
                        </List>
                    </Collapse>
                    <ListItem disablePadding>
                        <ListItemButton
                            selected={isSubmitRoute}
                            onClick={() => setSubmitClaimsExpanded(!submitClaimsExpanded)}
                        >
                            <ListItemIcon style={{ marginLeft: '10px' }}>
                                <NoteAltOutlined style={{ color: '#b6d6ef' }} />
                            </ListItemIcon>
                            <ListItemText>Claims</ListItemText>
                            {submitClaimsExpanded ? <ExpandLess /> : <ExpandMore />}
                        </ListItemButton>
                    </ListItem>
                    <Collapse in={submitClaimsExpanded}>
                        <List component="div" disablePadding style={{ marginLeft: '10px' }}>
                            <ListItemButton
                                selected={pathname === '/submit/dental'}
                                onClick={() => navigate('/submit/dental')}
                            >
                                <ListItemIcon style={{ marginLeft: '10px' }} />
                                <ListItemText>Dental</ListItemText>
                            </ListItemButton>
                            <ListItemButton
                                selected={pathname === '/submit/raw'}
                                onClick={() => navigate('/submit/raw')}
                            >
                                <ListItemIcon style={{ marginLeft: '10px' }} />
                                <ListItemText>EDI</ListItemText>
                            </ListItemButton>
                            <ListItemButton
                                selected={pathname === '/lookup'}
                                onClick={() => navigate('/lookup')}
                            >
                                <ListItemIcon style={{ marginLeft: '10px' }} />
                                <ListItemText>Lookup</ListItemText>
                            </ListItemButton>
                        </List>
                    </Collapse>
                    <ListItem disablePadding>
                        <ListItemButton
                            selected={pathname === '/requests'}
                            onClick={() => navigate('/requests')}
                        >
                            <ListItemIcon style={{ marginLeft: '10px' }}>
                                <MoveToInbox style={{ color: '#b6d6ef' }} />
                            </ListItemIcon>
                            <ListItemText>
                                Requests{' '}
                                {requests.length !== undefined && requests.length > 0 && (
                                    <span
                                        style={{
                                            marginLeft: '20px',
                                            backgroundColor: '#5B7E97',
                                            borderRadius: '5px',
                                            padding: '4px 10px 4px 10px',
                                        }}
                                    >
                                        {requests.length}
                                    </span>
                                )}
                            </ListItemText>
                        </ListItemButton>
                    </ListItem>
                    <ListItem disablePadding>
                        <ListItemButton
                            selected={pathname === '/notifications'}
                            onClick={() => navigate('/notifications')}
                        >
                            <ListItemIcon style={{ marginLeft: '10px' }}>
                                <Notifications style={{ color: '#b6d6ef' }} />
                            </ListItemIcon>
                            <ListItemText>
                                Notifications{' '}
                                {notifications.length !== undefined && notifications.length > 0 && (
                                    <span
                                        style={{
                                            marginLeft: '20px',
                                            backgroundColor: '#5B7E97',
                                            borderRadius: '5px',
                                            padding: '4px 10px 4px 10px',
                                        }}
                                    >
                                        {notifications.length}
                                    </span>
                                )}
                            </ListItemText>
                        </ListItemButton>
                    </ListItem>
                    <ListItem disablePadding>
                        <ListItemButton
                            selected={isIntegrationRoute}
                            onClick={() => setClaimsIntegrationExpanded(!claimsIntegrationExpanded)}
                        >
                            <ListItemIcon style={{ marginLeft: '10px' }}>
                                <MoveToInbox style={{ color: '#b6d6ef' }} />
                            </ListItemIcon>
                            <ListItemText>Integration</ListItemText>
                            {claimsIntegrationExpanded ? <ExpandLess /> : <ExpandMore />}
                        </ListItemButton>
                    </ListItem>
                    <Collapse in={claimsIntegrationExpanded}>
                        <List component="div" disablePadding style={{ marginLeft: '10px' }}>
                            <ListItemButton
                                selected={pathname === '/api/claims'}
                                onClick={() => navigate('/api/claims')}
                            >
                                <ListItemIcon style={{ marginLeft: '10px' }} />
                                <ListItemText>Claims</ListItemText>
                            </ListItemButton>
                            {
                                // eslint-disable-next-line etc/no-commented-out-code
                                /* <ListItem disablePadding>
                                <ListItem
                                    selected={pathname === '/contracts'}
                                    button
                                    onClick={() => navigate('/contracts')}
                                >
                                    <ListItemIcon style={{ marginLeft: '10px' }} />
                                    <ListItemText>Contracts</ListItemText>
                                </ListItem>
                            </ListItem> */
                            }
                        </List>
                    </Collapse>
                    <ListItem disablePadding>
                        <ListItemButton
                            selected={pathname === '/settings'}
                            onClick={() => navigate('/settings')}
                        >
                            <ListItemIcon style={{ marginLeft: '10px' }}>
                                <Settings style={{ color: '#b6d6ef' }} />
                            </ListItemIcon>
                            <ListItemText>Settings</ListItemText>
                        </ListItemButton>
                    </ListItem>
                </List>
            </Box>
            <Box
                style={{
                    display: 'flex',
                    marginTop: '50px',
                    justifyContent: 'center',
                    alignItems: 'center',
                }}
            >
                <img src="/img/rhiza_logo.png" alt="" height={28} />
                <Typography style={{ marginLeft: '10px', fontSize: '22px' }}>
                    <span style={{ fontWeight: '600' }}>Rhiza</span> Health
                </Typography>
            </Box>
        </Drawer>
    )
}
